import {
  installEnterpriseInterceptor,
  installGlobalEnterpriseInterceptor
} from "../auth/enterpriseSession";

// AUTH003_ENTERPRISE
import axios from "axios";

/**
 * =========================
 * BASE URLS (2 APIs)
 * =========================
 * - Inventario (API vieja): egt2axq41g...
 * - Reportes (API nueva): p3mslv2vz1...
 *
 * Ã¢Å“â€¦ NO rompe nada: si no pones envs, usa defaults.
 */

// Ã¢Å“â€¦ API INVENTARIO (vieja) - DEFAULT
export const API_INVENTARIO_BASE =
  process.env.REACT_APP_API_INVENTARIO ||
  process.env.REACT_APP_API_BASE || // fallback por compatibilidad (si ya lo usabas)
  "https://egt2axq41g.execute-api.us-east-1.amazonaws.com/dev";

// Ã¢Å“â€¦ API REPORTES (nueva)
export const API_REPORTES_BASE =
  process.env.REACT_APP_API_REPORTES ||
  "https://x7ur7541m7.execute-api.us-east-1.amazonaws.com/dev";


  // Ã¢Å“â€¦ API EMPLEADOS 
export const API_EMPLEADOS_BASE =
  process.env.REACT_APP_API_EMPLEADOS ||
  "https://y22q5rq94a.execute-api.us-east-1.amazonaws.com/dev";

// API COTIZACIONES - backend aislado consumibles PVC
export const API_COTIZACIONES_BASE =
  process.env.REACT_APP_API_COTIZACIONES ||
  "https://n0d3fdnckg.execute-api.us-east-1.amazonaws.com/dev";

// Ã¢Å“â€¦ API KEY desde .env (si la usas)
const API_KEY = process.env.REACT_APP_API_KEY || "";

/**
 * =========================
 * INSTANCIAS
 * =========================
 */

// Ã¢Å“â€¦ Inventario: mantiene TODO lo que ya usabas
export const httpInventario = axios.create({
  baseURL: API_INVENTARIO_BASE,
  headers: {
    ...(API_KEY ? { "x-api-key": API_KEY } : {}),
  },
});

// Ã¢Å“â€¦ Reportes: para /reportes/* (incluye Documentos)
export const httpReportes = axios.create({
  baseURL: API_REPORTES_BASE,
  headers: {
    ...(API_KEY ? { "x-api-key": API_KEY } : {}),
  },
});

// Ã¢Å“â€¦ Empleados: backend aislado
export const httpEmpleados = axios.create({
  baseURL: API_EMPLEADOS_BASE,
  headers: {
    ...(API_KEY ? { "x-api-key": API_KEY } : {}),
  },
});

// Cotizaciones: backend aislado consumibles PVC
export const httpCotizaciones = axios.create({
  baseURL: API_COTIZACIONES_BASE,
  headers: {
    ...(API_KEY ? { "x-api-key": API_KEY } : {}),
  },
});

/**
 * =========================
 * INTERCEPTOR (en ambas)
 * =========================
 * agrega Authorization SIEMPRE (para endpoints protegidos)
 */
function attachAuth(config) {
  const idToken = localStorage.getItem("idToken"); // Ã¢Å“â€¦ PRIMERO
  const accessToken = localStorage.getItem("accessToken"); // fallback
  const token = idToken || accessToken;

  if (token) {
    config.headers = config.headers || {};
    config.headers.Authorization = token; // Ã¢Å“â€¦ SIN "Bearer "
  }
  return config;
}

function attachAuthEmpleados(config) {
  const idToken = localStorage.getItem("idToken");
  const accessToken = localStorage.getItem("accessToken");
  const token = idToken || accessToken;

  if (token) {
    config.headers = config.headers || {};
    config.headers.Authorization = token;
  }

  return config;
}




httpInventario.interceptors.request.use(attachAuth);
httpReportes.interceptors.request.use(attachAuth);
httpEmpleados.interceptors.request.use(attachAuthEmpleados);
httpCotizaciones.interceptors.request.use(attachAuth);

/**
 * =========================
 * Ã°Å¸â€Â PIN TOKEN (COPY-ONLY)
 * =========================
 * Guardamos pinToken temporal (5 min) en sessionStorage.
 * Ã¢Å“â€¦ No rompe nada si no lo usas.
 */
const PIN_TOKEN_KEY = "pinToken";
const PIN_TOKEN_EXP_KEY = "pinTokenExp"; // epoch ms

export function setPinToken(pinToken, expiresInSeconds = 300) {
  const exp = Date.now() + (Number(expiresInSeconds) || 300) * 1000;
  sessionStorage.setItem(PIN_TOKEN_KEY, String(pinToken || ""));
  sessionStorage.setItem(PIN_TOKEN_EXP_KEY, String(exp));
}

export function getPinToken() {
  const token = sessionStorage.getItem(PIN_TOKEN_KEY) || "";
  const expRaw = sessionStorage.getItem(PIN_TOKEN_EXP_KEY) || "0";
  const exp = Number(expRaw) || 0;

  if (!token) return "";
  if (Date.now() > exp) {
    sessionStorage.removeItem(PIN_TOKEN_KEY);
    sessionStorage.removeItem(PIN_TOKEN_EXP_KEY);
    return "";
  }
  return token;
}

export function clearPinToken() {
  sessionStorage.removeItem(PIN_TOKEN_KEY);
  sessionStorage.removeItem(PIN_TOKEN_EXP_KEY);
}

/**
 * =========================
 * Ã¢Å“â€¦ VERIFY PIN (API vieja)
 * =========================
 * POST /credenciales/verify-pin  => { ok, pinToken, expiresInSeconds }
 */
export const verifyPin = async (pin) => {
  const res = await httpInventario.post(`/credenciales/verify-pin`, {
    pin: String(pin || "").trim(),
  });

  const data = res?.data ?? res;

  if (!data?.ok || !data?.pinToken) {
    throw new Error(data?.message || data?.error || "PIN invÃ¡lido");
  }

  setPinToken(data.pinToken, data.expiresInSeconds || 300);
  return data;
};

/**
 * =========================
 * EXPORT DEFAULT (compat)
 * =========================
 * Mantengo default = httpInventario para NO romper imports existentes
 */
const http = httpInventario;

/* =========================
   INVENTARIO (API vieja)
========================= */
export const getInventario = () => httpInventario.get(`/inventario`);
export const createInventario = (data) => httpInventario.post(`/inventario`, data);
export const updateInventario = (id, data) => httpInventario.put(`/inventario/${id}`, data);
export const deleteInventario = (id) => httpInventario.delete(`/inventario`, { data: { id } });
export const buscarPorSerie = (serie) =>
  httpInventario.get(`/inventario/buscar?serie=${encodeURIComponent(serie)}`);

/* =========================
   EQUIPOS (API vieja)
========================= */
export const getEquipos = () => httpInventario.get(`/equipos`);
export const createEquipo = (data) => httpInventario.post(`/equipos`, data);
export const updateEquipo = (id, data) => httpInventario.put(`/equipos/${id}`, data);
export const deleteEquipo = (id) => httpInventario.delete(`/equipos/${id}`);

/* =========================
   CONTRATOS (API vieja)
========================= */
export const getContratos = () => httpInventario.get(`/contratos`);
export const createContrato = (data) => httpInventario.post(`/contratos`, data);
export const updateContrato = (id, data) => httpInventario.put(`/contratos/${id}`, data);
export const deleteContrato = (id) => httpInventario.delete(`/contratos/${id}`);


/* =========================
   EMPLEADOS / DIRECTORIO
   API AISLADA - BACKEND REAL
========================= */
export const getEmpleados = () => httpEmpleados.get(`/empleados`);

export const getEmpleadoById = (id) =>
  httpEmpleados.get(`/empleados/${encodeURIComponent(id)}`);

export const createEmpleado = (data) =>
  httpEmpleados.post(`/empleados`, data);

export const updateEmpleado = (id, data) =>
  httpEmpleados.put(`/empleados/${encodeURIComponent(id)}`, data);

export const deleteEmpleado = (id) =>
  httpEmpleados.delete(`/empleados/${encodeURIComponent(id)}`);

/* =========================
   INCIDENCIAS (API vieja)
========================= */
export const getIncidencias = () => httpInventario.get(`/incidencias`);
export const createIncidencia = (data) => httpInventario.post(`/incidencias`, data);
export const updateIncidenciaEstado = (data) => httpInventario.put(`/incidencias/estado`, data);

// Ã¢Å“â€¦ NUEVO: GET incidencia por ID
export const getIncidenciaById = (id) => httpInventario.get(`/incidencias/${encodeURIComponent(id)}`);

// Ã¢Å“â€¦ NUEVO: Generar/descargar PDF de incidencia
export const generateIncidenciaPdf = (id) =>
  httpInventario.post(`/incidencias/${encodeURIComponent(id)}/pdf`, {});

// Ã¢Å“â€¦ NUEVO: Eliminar incidencia por ID
export const deleteIncidencia = (id) => httpInventario.delete(`/incidencias/${encodeURIComponent(id)}`);

/* =========================
   CONFIGURACIÃƒâ€œN (API vieja)
========================= */
export const getConfig = () => httpInventario.get(`/config`);
export const createConfig = (data) => httpInventario.post(`/config`, data);

/* =========================
   Ã°Å¸â€Â CREDENCIALES (API vieja)
========================= */
export const getCredenciales = () => httpInventario.get(`/credenciales`);
export const createCredencial = (data) => httpInventario.post(`/credenciales`, data);
export const updateCredencial = (id, data) => httpInventario.put(`/credenciales/${id}`, data);
export const deleteCredencial = (id) => httpInventario.delete(`/credenciales/${id}`);

/**
 * Ã¢Å“â€¦ getCredencialSecret ahora manda X-Pin-Token si existe.
 * NO rompe nada: si no hay pinToken, manda igual que antes.
 */
export const getCredencialSecret = (id) => {
  const pinToken = getPinToken();

  return httpInventario.get(`/credenciales/${encodeURIComponent(id)}/secret`, {
    headers: {
      ...(pinToken ? { "X-Pin-Token": pinToken } : {}),
    },
  });
};

/* =========================
   Ã¢Å“â€¦ DOCUMENTOS (API reportes)
========================= */

// 1) Generar URL firmada para subir (S3 PUT)
export const getUploadUrlDocs = (payload) =>
  httpReportes.post(`/reportes/documentos/upload-url`, payload);

// Ã¢Å“â€¦ 2) Confirmar subida (guardar metadata en DynamoDB catÃ¡logo)
export const confirmUploadDocs = (payload) =>
  httpReportes.post(`/reportes/documentos/confirm`, payload);

// Ã¢Å“â€¦ 3) Listar documentos (legacy)
export const listDocs = (params) => httpReportes.get(`/reportes/documentos`, { params });
// ======================================================
// DRIVE DOCUMENTAL: CARPETAS REALES
// ======================================================

export const createDocumentFolder = (payload) =>
  httpReportes.post(
    `/reportes/documentos/folders`,
    payload
  );

export const listDocumentFolders = (params) =>
  httpReportes.get(
    `/reportes/documentos/folders`,
    { params }
  );
export const deleteDocumentFolder = (folderId, projectName) =>
  httpReportes.delete(
    `/reportes/documentos/folders/${encodeURIComponent(folderId)}`,
    { params: { projectName } }
  );
// Ã¢Å“â€¦ 3B) Buscar documentos (nuevo escalable / typeahead)
export const searchDocs = (params) => httpReportes.get(`/reportes/documentos/search`, { params });

// Ã¢Å“â€¦ 4) Descargar por documentId (URL firmada GET)
export const getDownloadUrlDoc = (documentId) =>
  httpReportes.get(`/reportes/documentos/${encodeURIComponent(documentId)}/download`);

// Ã¢Å“â€¦ 5) (NUEVO) Actualizar status del documento (pipeline)
export const updateDocStatus = (payload) =>
  httpReportes.patch(`/reportes/documentos/status`, payload);

// Ã¢Å“â€¦ 6) (NUEVO) Eliminar documento (S3 + marcar DELETED en Dynamo)
export const deleteDoc = (documentId) =>
  httpReportes.delete(`/reportes/documentos/${encodeURIComponent(documentId)}`);

// (Opcional) Legacy: si en algÃºn lugar ya lo usabas, lo dejo intacto.
export const getDownloadUrlDocs = (payload) =>
  httpReportes.post(`/reportes/documentos/download-url`, payload);


export default http;

// ======================================================
// PROYECTOS / CENTRO DE CONTROL
// API AISLADA - BACKEND REAL
// ======================================================

// ======================================================
// PROYECTOS / CENTRO DE CONTROL
// API AISLADA - BACKEND REAL
// ======================================================

export const API_PROYECTOS_BASE =
  process.env.REACT_APP_API_PROYECTOS ||
  "https://g4xylhvnxf.execute-api.us-east-1.amazonaws.com/dev";

function getProyectoToken() {
  return localStorage.getItem("idToken") || localStorage.getItem("accessToken") || "";
}

async function requestProyectos(path, options = {}) {
  const token = getProyectoToken();

  const headers = {
    ...(options.body ? { "Content-Type": "application/json" } : {}),
    ...(token ? { Authorization: token } : {}),
    ...(options.headers || {}),
  };

  const response = await fetch(`${API_PROYECTOS_BASE}${path}`, {
    ...options,
    headers,
  });

  const text = await response.text();
  let data = {};

  try {
    data = text ? JSON.parse(text) : {};
  } catch {
    data = { raw: text };
  }

  if (!response.ok) {
    const error = new Error(`Proyectos API error ${response.status}`);
    error.status = response.status;
    error.data = data;
    throw error;
  }

  // Forma compatible con axios: response.data
  return { data, status: response.status };
}

export const getProyectos = () =>
  requestProyectos(`/proyectos`);

export const getProyectoById = (id) =>
  requestProyectos(`/proyectos/${encodeURIComponent(id)}`);

export const createProyecto = (data) =>
  requestProyectos(`/proyectos`, {
    method: "POST",
    body: JSON.stringify(data),
  });

export const updateProyecto = (id, data) =>
  requestProyectos(`/proyectos/${encodeURIComponent(id)}`, {
    method: "PUT",
    body: JSON.stringify(data),
  });

export const deleteProyecto = (id) =>
  requestProyectos(`/proyectos/${encodeURIComponent(id)}`, {
    method: "DELETE",
  });

export const getProyectoEventos = (id) =>
  requestProyectos(`/proyectos/${encodeURIComponent(id)}/eventos`);

export const createProyectoEvento = (id, data) =>
  requestProyectos(`/proyectos/${encodeURIComponent(id)}/eventos`, {
    method: "POST",
    body: JSON.stringify(data),
  });

export const applyProyectoAction = (id, data) =>
  requestProyectos(`/proyectos/${encodeURIComponent(id)}/acciones`, {
    method: "POST",
    body: JSON.stringify(data),
  });

// =========================
// COTIZACIONES CONSUMIBLES PVC
// =========================

export async function getCotizaciones() {
  const res = await httpCotizaciones.get("/cotizaciones");
  return res.data;
}

export async function getCotizacion(id) {
  const res = await httpCotizaciones.get(`/cotizaciones/${id}`);
  return res.data;
}

export async function createCotizacion(data) {
  const res = await httpCotizaciones.post("/cotizaciones", data);
  return res.data;
}

export async function updateCotizacion(id, data) {
  const res = await httpCotizaciones.put(`/cotizaciones/${id}`, data);
  return res.data;
}

export async function deleteCotizacion(id) {
  const res = await httpCotizaciones.delete(`/cotizaciones/${id}`);
  return res.data;
}

export async function getCotizacionEventos(id) {
  const res = await httpCotizaciones.get(`/cotizaciones/${id}/eventos`);
  return res.data;
}

export async function createCotizacionEvento(id, data) {
  const res = await httpCotizaciones.post(`/cotizaciones/${id}/eventos`, data);
  return res.data;
}

// ======================================================
// DMS PROJECTS - GESTION DOCUMENTAL AISLADA
// No pertenece al Centro de Control de Proyectos.
// ======================================================

export const API_DMS_PROJECTS_BASE =
  process.env.REACT_APP_API_DMS_PROJECTS ||
  "https://xynrnnnaub.execute-api.us-east-1.amazonaws.com/dev";

async function requestDmsProjects(requestPath, options = {}) {
  const token =
    localStorage.getItem("idToken") ||
    localStorage.getItem("accessToken") ||
    "";

  const headers = {
    ...(options.body
      ? { "Content-Type": "application/json" }
      : {}),
    ...(token ? { Authorization: token } : {}),
    ...(options.headers || {}),
  };

  const response = await fetch(
    `${API_DMS_PROJECTS_BASE}${requestPath}`,
    {
      ...options,
      headers,
    }
  );

  const text = await response.text();
  let data = {};

  try {
    data = text ? JSON.parse(text) : {};
  } catch {
    data = { raw: text };
  }

  if (!response.ok) {
    const error = new Error(
      data?.message ||
      `DMS Projects API error ${response.status}`
    );

    error.status = response.status;
    error.data = data;
    error.response = {
      status: response.status,
      data,
    };

    throw error;
  }

  return {
    data,
    status: response.status,
  };
}

export const listDmsProjects = () =>
  requestDmsProjects("/dms/projects");

export const createDmsProject = (payload) =>
  requestDmsProjects("/dms/projects", {
    method: "POST",
    body: JSON.stringify(payload),
  });

export const deleteDmsProject = (projectName) =>
  requestDmsProjects(
    `/dms/projects/${encodeURIComponent(projectName)}`,
    {
      method: "DELETE",
    }
  );


// ============================================================
// COTIZACIONES - COMPARATIVO GOOGLE SHEETS
// ============================================================

export async function getComparativoCotizaciones() {
  const res = await httpCotizaciones.get(
    "/cotizaciones/comparativo"
  );

  return res.data;
}


// AUTH003_ENTERPRISE - INTERCEPTORES
installEnterpriseInterceptor(httpInventario);
installEnterpriseInterceptor(httpReportes);
installEnterpriseInterceptor(httpEmpleados);
installEnterpriseInterceptor(httpCotizaciones);
installGlobalEnterpriseInterceptor();